import { render } from "./BarcodeIconLabel.vue?vue&type=template&id=4c0f62d2"
import script from "./BarcodeIconLabel.vue?vue&type=script&lang=ts"
export * from "./BarcodeIconLabel.vue?vue&type=script&lang=ts"

import "./BarcodeIconLabel.vue?vue&type=style&index=0&id=4c0f62d2&lang=css"
script.render = render

export default script